import { queryOptions } from "@tanstack/react-query";

import { getSuitePlanOffer } from "~/lib/functions/suite-plan-offer";

/**
 * The live prices on the Marketing Suite "Your plan" page. No user id in the
 * key, like the other coach queries: the server answers for the signed-in
 * coach. A failed read is not retried: the page leaves its price sentences out
 * and everything else stays.
 */
export function suitePlanOfferQueryOptions() {
  return queryOptions({
    queryKey: ["suite-plan-offer"],
    queryFn: () => getSuitePlanOffer(),
    staleTime: 60 * 1000,
    retry: false,
  });
}
